import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Internal Formly FieldType Component
 * Used internally by InputFieldWrapperComponent and Formly forms.
 * Do not use this directly - use InputFieldWrapperComponent instead.
 */
@Component({
  selector: 'era-formly-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ReactiveFormsModule, FormlyModule, FaIconComponent],
})
export class InputFieldComponent extends FieldType<FieldTypeConfig> {
  showPassword = false;
  get type(): string {
    return this.props.type || 'text';
  }
  get placeholder(): string {
    return this.props.placeholder || '';
  }
  get required(): boolean {
    return this.props.required || false;
  }
  get disabled(): boolean {
    return this.props.disabled || false;
  }
  get readonly(): boolean {
    return this.props.readonly || false;
  }
  get maxLength(): number | undefined {
    return this.props.maxLength;
  }
  get minLength(): number | undefined {
    return this.props.minLength;
  }
  get pattern(): string | undefined {
    return this.props.pattern ? String(this.props.pattern) : undefined;
  }
  get labelPosition(): 'top' | 'inline' {
    return this.props.labelPosition || 'top';
  }
  get labelWidth(): string | undefined {
    return this.props.labelWidth;
  }
  get showPasswordToggle(): boolean {
    return this.props.showPasswordToggle || false;
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  get password(): string {
    if (this.type === 'password' && this.showPasswordToggle && this.showPassword) {
      return 'text';
    }
    return this.type;
  }
}
